import { ClaimGroupMessages, TranslationClaimGroupMessages } from "../interfaces";

export const messages : TranslationClaimGroupMessages = {
  [ClaimGroupMessages.concreteBatchingPlant]: "Central",
  [ClaimGroupMessages.gravel]: "Britas",
  [ClaimGroupMessages.supply]: "Insumos",
  [ClaimGroupMessages.characteristic]: "Características",
  [ClaimGroupMessages.classification]: "Classificação",
  [ClaimGroupMessages.supplier]: "Fornecedor",
  [ClaimGroupMessages.concreteBatchingPlantGroup]: "Grupo de centrais",
  [ClaimGroupMessages.productGroup]: "Grupo de produtos",
  [ClaimGroupMessages.concreteRecipe]: "Produtos",
  [ClaimGroupMessages.concreteBatchingPlantRegional]: "Regional de centrais",
  [ClaimGroupMessages.slump]: "Slumps",
  [ClaimGroupMessages.measureUnitType]: "Unidade de medida",
  [ClaimGroupMessages.technicalDataSupply]: "Dados técnicos",
  [ClaimGroupMessages.costSupply]: "Custos",
  [ClaimGroupMessages.abramsCurve]: "Curva de abrams",
  [ClaimGroupMessages.concreteRecipeFamily]: "Família de traços",
  [ClaimGroupMessages.copyInBatch]: "Cópia em lote",
  [ClaimGroupMessages.changeInBatch]: "Alteração em lote",
  [ClaimGroupMessages.userRightsControl]: "Controle de direitos do usuário",
  [ClaimGroupMessages.externalId]: "ID externo",
  [ClaimGroupMessages.csvImport]: "Importar CSV",
  [ClaimGroupMessages.concreteMixDesignSheet]: "Carta traço",
  [ClaimGroupMessages.concreteMixDesignSheetParameters]: "Parâmetros da carta traço",
  [ClaimGroupMessages.aggregateTest]: "Ensaio de agregado",
  [ClaimGroupMessages.aggregateTestReport]: "Laudo",
  [ClaimGroupMessages.sieve]: "Peneiras",
  [ClaimGroupMessages.responsibleEngineer]: "Engenheiro responsável",
  [ClaimGroupMessages.laboratory]: "Laboratório",
  [ClaimGroupMessages.laboratoryTechnician]: "Laboratorista",
  [ClaimGroupMessages.standard]: "Normas",
  [ClaimGroupMessages.integrations]: "Integrações",
  [ClaimGroupMessages.vehicles]: "Veículos",
  [ClaimGroupMessages.employees]: "Funcionários",
  [ClaimGroupMessages.reports]: "Relatórios",
  [ClaimGroupMessages.generalParameters]: "Parâmetros Gerais",
  [ClaimGroupMessages.expedition]: "Expedição",
  [ClaimGroupMessages.aggregateMoisture]: "Umidade do Agregado",
  [ClaimGroupMessages.loadTickets]: "Tickets de pesagem",
  [ClaimGroupMessages.deliveriesTickets]: "Remessas",
  [ClaimGroupMessages.loadReuse]: "Reaproveitamento de Carga",
  [ClaimGroupMessages.invoices]: "Notas fiscais",
  [ClaimGroupMessages.weighingLink]: "Vínculo de Pesagens",
  [ClaimGroupMessages.inventory]: "Estoque",
  [ClaimGroupMessages.inventoryClosure]: "Fechamento de estoque",
  [ClaimGroupMessages.dailyClosing]: "Fechamento diário",
  [ClaimGroupMessages.invoiceStub]: "Canhoto de nota",
  [ClaimGroupMessages.approvalOfAdditionalFees]: "Aprovação de Taxas Adicionais",
  [ClaimGroupMessages.schedulings]: "Programações",
  [ClaimGroupMessages.concreteBatchingPlantGroupDispatch]: "Grupo de Centrais de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantRegionalDispatch]: "Regional de Centrais de Concreto",
  [ClaimGroupMessages.delivery]: "Entrega",
  [ClaimGroupMessages.reservation]: "Reserva",
  [ClaimGroupMessages.concreteBatchingPlantsDispatch]: "Centrais de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantGeneralParameters]: "Parâmetros Gerais da Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantOpeningHoursParameters]: "Parâmetros de Horário de Funcionamento da Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantAverageDurationParameters]: "Parâmetros de Duração Média da Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantMoldingParameters]: "Parâmetros de Moldagem da Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantDailyClosingParameters]: "Parâmetros de Fechamento Diário da Central de Concreto",
  [ClaimGroupMessages.concreteBatchingPlantTaxDocumentParameters]: "Parâmetros de Documento Fiscal da Central de Concreto",
  [ClaimGroupMessages.loadingPoints]: "Pontos de Carga",
  [ClaimGroupMessages.loadingPointLocations]: "Local de Pontos de Carga",
  [ClaimGroupMessages.deliveryRoutes]: "Rotas de Entrega",
  [ClaimGroupMessages.pumpingTypes]: "Tipos de Bombeamento",
  [ClaimGroupMessages.piecesToBeConcreted]: "Peças a Concretar",
  [ClaimGroupMessages.defaultDurationsByPumpingType]: "Durações Padrão por Tipo de Bombeamento",
  [ClaimGroupMessages.holidays]: "Feriados",
  [ClaimGroupMessages.reasons]: "Motivos",
  [ClaimGroupMessages.taxConfigurationConcreteRecipe]: "Configuração de Impostos de Traço de Concreto",
  [ClaimGroupMessages.users]: "Usuários",
  [ClaimGroupMessages.groups]: "Grupos",
  [ClaimGroupMessages.alerts]: "Alertas",
  [ClaimGroupMessages.concreteDiscardDestination]: "Destino de descarte",
  [ClaimGroupMessages.loadTicketBlockReason]: "Motivo de bloqueio de ticket de carga",
  [ClaimGroupMessages.pumpingBlockReason]: "Motivo de bloqueio de bombeamento",
  [ClaimGroupMessages.batchMaintenanceView]: "Visualização de Tarefas de Manutenção",
  [ClaimGroupMessages.batchMaintenanceEdit]: "Edição de Tarefas de Manutenção",
  [ClaimGroupMessages.batchMaintenanceExecute]: "Execução de Tarefas de Manutenção",
  [ClaimGroupMessages.batchAutomationView]: "Visualização de Automação",
  [ClaimGroupMessages.batchAutomationExecute]: "Execução de Automação",
  [ClaimGroupMessages.batchAutomationAdmin]: "Administração de Automação",
  [ClaimGroupMessages.batchAutomationSuperAdmin]: "Super Administração de Automação",
  [ClaimGroupMessages.dailyProductionClosingInconsistencies]: "Inconsistências no fechamento da produção diária",
  [ClaimGroupMessages.timeRecords]: "Manutenção de Pontos",
  [ClaimGroupMessages.timeClockConfigurations]: "Configuração de Relógio de Ponto",
  [ClaimGroupMessages.performance]: "Indicadores de Performance (KPIs)",
  [ClaimGroupMessages.laboratoryModule]: "Acesso ao laboratório",
  [ClaimGroupMessages.specimenCollection]: "Coleta de corpos de prova",
  [ClaimGroupMessages.specimenRupture]: "Rompimento de corpos de prova",
  [ClaimGroupMessages.deliveryTicketSpecimens]: "Painel de remessas/amostras",
  [ClaimGroupMessages.collectionSchedule]: "Agenda de coleta",
  [ClaimGroupMessages.ruptureSchedule]: "Agenda de rompimento",
  [ClaimGroupMessages.issueCertificate]: "Emitir certificado",
  [ClaimGroupMessages.issuedCertificates]: "Certificados emitidos",
  [ClaimGroupMessages.presses]: "Prensas",
  [ClaimGroupMessages.certificateParameters]: "Parâmetros do certificado de resistência",
  [ClaimGroupMessages.laboratoryStatistics]: "Estatísticas do laboratório",
  [ClaimGroupMessages.lowStrengthApproval]: "Aprovação de resistências baixas"
};
